import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api/axiosInstance";

export const useYears = () => {
  return useQuery({
    queryKey: ["years"],
    queryFn: async () => {
      const response = await axiosInstance.get("api/allyears");
      return response.data;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
